import { Row, Col } from 'react-bootstrap';
import {
  SubSectionHeading,
  HeadingDesc,
  SectionHeadingSmall
} from '../../../Components/Headings';
import SimpleCard from '../../../Components/Card/simpleCard/SimpleCard';
import SectionWithTwoCards from '../../../Components/sectionsWithTwoCards/SectionWithTwoCards';
import { RightArrowWithBorder } from '../../../Components/icons';
import { AnchorLink } from '../../../Components/button';
import img1 from '../../../assets/images/png/health_measure.png';
import img2 from '../../../assets/images/png/inspiring_life.png';
import './monitorhealthSection.css';

function MonitorHealthSection() {
  return (
    <div className="monitorHealthSection">
      <SectionWithTwoCards
        secTopContent={<SectionTopContent />}
        rightCardContent={<RightCardContent />}
        leftCardContent={<LeftCardContent />}
      />
    </div>
  );
}

function SectionTopContent() {
  return (
    <>
      <SubSectionHeading
        text="حقیقی وقت میں اپنی صحت کی نگرانی کریں۔
"
      />
      <HeadingDesc
        text="ہمارے مصنوعی ذہانت کے الگورتھم کسی بھی فون یا لیپ ٹاپ کیمرہ کے ساتھ کام کرتے ہیں تاکہ 2 منٹ سے کم وقت میں آپ کے وائٹلز کو درست طریقے سے ناپ سکیں۔
"
      />
    </>
  );
}

function RightCardContent() {
  return (
    <SimpleCard bgColor="#FDEDF1">
      <Row>
        <Col md={10} lg={8}>
          <div className="content_container">
            <SectionHeadingSmall
              text="متاثر کن زندگی گزارنے کے نئے طریقے دریافت کریں۔
              "
              color="#EF6286"
            />
            <HeadingDesc
              text="صحت سے متعلق نکات، خوراک کے مشورے اور غذائی رہنمائی حاصل کریں۔
"
            />
          </div>
        </Col>
        <Col md={5}>
          <div className="btn_container">
            <RightArrowWithBorder />
            <AnchorLink text="اورجانیے" />
          </div>
        </Col>
        <Col md={7}>
          <div>
            <img src={img2} alt="inspiring_life" className="inspiring_life" />
          </div>
        </Col>
      </Row>
    </SimpleCard>
  );
}

function LeftCardContent() {
  return (
    <SimpleCard bgColor="#BEF5F1">
      <Row>
        <Col md={6}>
          <div className="content_container">
            <SectionHeadingSmall
              text="ہم صحت کی پیمائش کیسے نکالتے ہیں؟
              "
              color="#29BCC1"
            />
            <HeadingDesc
              text="میری صحت انسانی چہرے کی سطح پر بے نقاب جلد کی ویڈیو اسٹریم سے صحت کی پیمائش نکالتی ہے۔
"
            />
            <div className="btn_container">
              <RightArrowWithBorder />
              <AnchorLink text="اورجانیے" />
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className="text-lg-end text-center">
            <img src={img1} className="health_measure" alt="health_measure" />
          </div>
        </Col>
      </Row>
    </SimpleCard>
  );
}

export default MonitorHealthSection;
